export const ALL_PAYMENTWORKFLOW_REQUEST = "ALL_PAYMENTWORKFLOW_REQUEST"
export const ALL_PAYMENTWORKFLOW_SUCCESS = "ALL_PAYMENTWORKFLOW_SUCCESS"
export const ALL_PAYMENTWORKFLOW_FAIL = "ALL_PAYMENTWORKFLOW_FAIL"
export const CLEAR_ERRORS = "CLEAR_ERRORS"